<template>
  <Popover ref="glassLevelSelectPopover" :showHeader="true" headerTitle="Glass Select" :placement="placement">
    <div class="glass-level-info-popover-content">
      <Spinner v-if="loading" />
      <StaticDataTable class="static-table-list" v-if="!loading && stockData" variant="table-sm">
        <template v-slot:header>
           <tr>
              <th>Size (HxW) mm</th>
              <th>Level Size</th>
              <th>Sheets</th>
              <th>Blocks</th>
              <th>Total</th>
              <th>Ordered</th>
              <th>Available</th>
              <th>On Order</th>
              <th>Actions</th>
            </tr>
        </template>
        <template v-slot:body>
          <template v-for="glassSize in stockData.glassSizeList">
            <tr :key="glassSize.id">
              <td class="font-weight-bold">{{glassSize.height}} x {{glassSize.width}}</td>
              <td></td>
              <td class="font-weight-bold">{{glassSize.summary.totalSheets}}</td>
              <td class="font-weight-bold">{{glassSize.summary.totalBlocks}}</td>
              <td class="font-weight-bold">{{glassSize.summary.totalSheetStock}}</td>
              <td class="font-weight-bold">{{glassSize.summary.totalOrderEntry}}</td>
              <td class="font-weight-bold">{{glassSize.summary.totalAvailable}}</td>
              <td class="font-weight-bold">{{glassSize.summary.totalOnOrder}}</td>
              <td></td>
            </tr>
            <tr v-for="glassLevel in glassSize.glassLevels" :key="'level-' + glassLevel.id">
              <td></td>
              <td v-if="glassLevel.isOffcut" :class="{'stock-glass-level-offcut': glassLevel.isOffcut}">
                <Tooltip label="Offcut">
                  {{glassLevel.height}} x {{glassLevel.width}}
                </Tooltip>
              </td>
              <td v-else>
                {{glassLevel.height}} x {{glassLevel.width}}
              </td>
              <td>{{glassLevel.qtyOnHand}}</td>
              <td>{{glassLevel.summary.totalBlocks}}</td>
              <td>{{glassLevel.summary.totalSheetStock}}</td>
              <td>{{glassLevel.summary.totalOrderEntry}}</td>
              <td>{{glassLevel.summary.totalAvailable}}</td>
              <td>{{glassLevel.summary.totalOnOrder}}</td>
              <td>
                <button class="btn btn-sm btn-white" @click.prevent="selectGlassLevel(glassLevel)"><i class="far fa-check-circle"></i> Select</button>
              </td>
            </tr>
          </template>
        </template>
        <template v-slot:empty v-if="stockData && stockData.glassSizeList.length == 0">No glass levels found</template>
      </StaticDataTable>
      
    </div>
  </Popover>
</template>

<style scoped>
.glass-level-info-popover-content {
  padding: 6px;
  min-width: 700px;
  max-height: 300px;
  overflow-x: hidden;
  overflow-y: scroll;
}
</style>

<script>
import Popover from '@/components/popover.vue'
import StaticDataTable from '@/components/table/staticDataTable.vue'

export default {
  name: 'GlassLevelSelectPopover',
  components: {
    Popover,
    StaticDataTable
  },
  props: {
    placement: {
      type: String,
      default: 'bottom'
    },
  },
  data() {
    return {
      loading: false,
      stockId: null,
      stockData: null
    }
  },
  computed: {
  },
  created() {
  },
  mounted() {    
  },
  methods: {
    requestData() {
      this.loading = true
      this.$apiService.inventoryService.getStock(this.stockId)
      .then(response => {
        this.$data.stockData = response.data
      })
      .finally(() => {
        this.loading = false
      })
    },
    selectGlassLevel(glassLevel) {
      var glassLevelInfo = {
        id: glassLevel.id,
        width: glassLevel.width,
        height: glassLevel.height,
        isOffcut: glassLevel.isOffcut
      }

      this.$emit('selectGlassLevel', glassLevelInfo)
      this.$refs.glassLevelSelectPopover.hidePopover()
    },
    displayFromElement(element, stockId) {
      this.stockId = stockId
      this.requestData()

      this.$refs.glassLevelSelectPopover.displayFromElement(element)
    }
  }

}
</script>